export const MMAAssetConfigs = {
  MAX_HEADLINES: 15,
  DEFAULT_HEADLINES: 1,
  MIN_HEADLINES: 1,
  MAX_LONGHEADLINES: 5,
  DEFAULT_LONGHEADLINES: 1,
  MIN_LONGHEADLINES: 1,
  MAX_DESCRIPTIONS: 5,
  DEFAULT_DESCRIPTIONS: 1,
  MIN_DESCRIPTIONS: 1,
  MAX_HEADLINE_SUGGESTIONS: 15, // MAX_HEADLINES
  MAX_DESCRIPTION_SUGGESTIONS: 10, // MAX_DESCRIPTIONS + MAX_LONGHEADLINES
  MAX_BUSINESS_NAME: 25,
};


export const ResponsiveAdConfigs = {
  MAX_HEADLINE_SUGGESTIONS: 15,
  MAX_DESCRIPTION_SUGGESTIONS: 10,
};
